import axios from "axios";
import "../../filters";
import moment from "moment";
import users from "../../users";
import {
  DxDataGrid,
  DxColumn,
  DxGrouping,
  DxGroupPanel,
  DxSearchPanel,
  DxColumnChooser,
  DxExport,
  DxSelection,
  DxPaging,
  DxSorting,
  DxHeaderFilter,
  DxFilterPanel,
  DxFilterRow,
  DxFilterBuilderPopup,
  DxScrolling,
  DxSummary,
  DxStateStoring,
  DxGroupItem,
  DxTotalItem,
  DxEditing,
  DxPager,
} from "devextreme-vue/data-grid";
import localDataFunctions from "@/localDataFunctions";
import debounce from "lodash.debounce";

const edams_controls_tpl = {
  page: "omApplications_employee",
  controls: {
    sectionFilters: { employee: { visible: true, disabled: false } },
    sectionList: { employee: { visible: true, disabled: false } },
  },
};

const pickerDateFormat = "YYYY-M-D";
const uiDateFormat = "DD/MM/YYYY";

export default {
  name: "OmApplications",
  mixins: [users, localDataFunctions],
  components: {
    DxColumn,
    DxGroupPanel,
    DxGrouping,
    DxPaging,
    DxSorting,
    DxSearchPanel,
    DxColumnChooser,
    DxExport,
    DxSelection,
    DxHeaderFilter,
    DxFilterPanel,
    DxFilterRow,
    DxFilterBuilderPopup,
    DxScrolling,
    DxSummary,
    DxStateStoring,
    DxGroupItem,
    DxTotalItem,
    DxEditing,
    DxDataGrid,
    DxPager,
    EmptyState: require("@/customcontrols/emptyState/emptyState.vue").default,
  },
  data: function () {
    return {
      mobileView: false,

      searchMob: "",
      searchMobEnabled: true,

      edams_controls: edams_controls_tpl.controls,
      bShowSecurities: false,
      apps: [],
      formatedApps: [],
      message: "",
      showFilters: false,
      search: "",
      appTypes: [],
      appStatus: [],
      appStages: [],
      workflowEmployees: [],
      options: { pageSize: 10, total: 0, page: 1, from: null, to: null },
      totalRow: 0,
      omType: 0,
      omStatus: 0,
      assignedToEmployee: true,
      editButtons: [
        {
          hint: "Edit",
          icon: "edit",
          visible: true,
          onClick: this.editApp,
        },
      ],
      filterBuilderPopupPosition: {
        of: window,
        at: "top",
        my: "top",
        offset: { y: 10 },
      },
      bAutoExpand: true,
      bPageChange: true,
      viewOnlyAssignedApps: false,
    };
  },
  computed: {
    fromDate: function () {
      return this.options.from;
    },
    toDate: function () {
      return this.options.to;
    },
  },
  watch: {
    search: function (value) {
      this.debouncedFunc();
    },
    assignedToEmployee: function (value) {
      this.searchHandler();
    },
    omType: function (value) {
      this.searchHandler();
    },
    omStatus: function (value) {
      this.searchHandler();
    },
    fromDate: function () {
      this.searchHandler();
    },
    toDate: function () {
      this.searchHandler();
    },
    mobileView: function (value) {
      if (value == true) {
        // this.getOmApplicationsWithParam();
        this.searchHandler();
      }
    },
  },
  created() {
    this.debouncedFunc = debounce(() => this.searchHandler(), 4500);

    let pref = JSON.parse(
      this.$localStorage.get("_omApplications_filter_preferences")
    );
    if (pref) {
      this.search = pref.search;
      this.assignedToEmployee = pref.showMyApps;
      this.omType = pref.omType ?? 0;
      this.options.from = new Date(pref.startDate);
      this.options.to = new Date(pref.endDate);
      this.showFilters = pref.showFilters == false ? false : true;
    } else {
      this.omType = 0;
      this.options.to = new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        new Date().getDate() + 1
      );
      this.options.from = this.addMonths(this.options.to, -6);
    }

    this.readSecurities(edams_controls_tpl.page, this.edams_controls);
    this.omStatus = 0;

    this.getLookups();
    this.getWorkflowEmployees();
  },
  mounted() {
    let sett = this.$store.getters.getUserProfile;

    if (sett.viewOnlyAssignedApps) {
      this.viewOnlyAssignedApps = true;
      this.assignedToEmployee = true;
      this.assignedToEmployeeAction();
    } else this.viewOnlyAssignedApps = false;
  },
  beforeUnmount() {
    this.debouncedFunc.cancel();
  },
  methods: {
    resetFilters() {
      let date = new Date();

      this.search = "";

      this.assignedToEmployee = true;

      this.options = {
        pageSize: 10,
        page: 1,
        filterText: "",
        from: this.addMonths(date, -1),
        to: date,
      };

      this.omType =
        this.appTypes && this.appTypes.length ? this.appTypes[0].id : 0;

      this.searchHandler();
    },
    searchHandler() {
      var parameters = {
        Options: {
          PageSize: this.options.pageSize,
          Page: this.options.page,
          FilterText: this.search,
        },
        Type: this.omType,
        Status: this.omStatus,
        From: this.options.from,
        To: this.options.to,
        AssignedEmployeeId: this.assignedToEmployee,
      };

      this.getOmApplications(parameters);

      this.saveFilters();
    },
    saveFilters() {
      let filt = {
        search: this.search,
        showMyApps: this.assignedToEmployee == true,
        omType: this.omType ?? 0,
        startDate: moment(this.options.from).format(),
        endDate: moment(this.options.to).format(),
        showFilters: this.showFilters == true,
      };

      this.saveToLocal("_omApplications_filter_preferences", filt);
    },
    searchMobFunc(resetSearch) {
      if (resetSearch == true) {
        this.searchMobEnabled = true;
        this.searchMob = "";
        // this.getOmApplicationsWithParam();
        this.searchHandler();
        console.log("reset srcg");
      } else {
        this.searchMobEnabled = false;

        if (this.searchMob == "") return;

        let addr = "";
        let srch = "";

        let temp = this.apps.filter((a) => {
          addr = "";
          srch = "";

          if (a.jobcardId.toString().includes(this.searchMob)) return true;

          addr = a.problemAddress != null ? a.problemAddress.toLowerCase() : "";
          srch = this.searchMob != null ? this.searchMob.toLowerCase() : "";
          if (addr.includes(srch)) return true;
        });

        if (temp != null && temp.length > 0) this.apps = temp;
        else {
          this.searchMobEnabled = true;
          this.$alertMsg("No results found during the search!", 1);
        }
      }
    },
    showFiltersFunc() {
      this.showFilters = !this.showFilters;

      let pref = {
        showFilters: this.showFilters,
      };

      this.saveFilters();
    },
    manageSecurities(event) {
      this.bShowSecurities = !this.bShowSecurities;
      if (this.bShowSecurities === true)
        this.showSecurities(this.edams_controls);
      else this.readSecurities(edams_controls_tpl.page, this.edams_controls);
    },
    dateIdSortDesc(a, b) {
      if (
        new Date(b.applicationDate).getTime() ===
        new Date(a.applicationDate).getTime()
      ) {
        return b.valueId - a.valueId;
      }
      return (
        new Date(b.applicationDate).getTime() -
        new Date(a.applicationDate).getTime()
      );
    },
    pageChange(pInfo) {
      if (this.bPageChange === true) this.bPageChange = false;
      else {
        this.options.pageSize = pInfo.pageSize;
        this.options.page = pInfo.pageNumber;
        var parameters = {
          Options: {
            PageSize: this.options.pageSize,
            Page: this.options.page,
            FilterText: this.search,
          },
          Type: this.omType,
          Status: this.omStatus,
          From: this.options.from,
          To: this.options.to,
          AssignedEmployeeId: this.assignedToEmployee,
        };
        this.getOmApplications(parameters);
      }
    },
    getOmApplications(parameters) {
      this.saveFilters();

      if (!parameters) {
        console.log("No parameters provided");
        return;
      }
      this.$store.state.notifier.asyncBlock(
        axios.post("/Om/GetApplications", parameters),
        (response) => {
          if (response.status === 200 && response.data.data.status === 0) {
            response.data.items.forEach((item) => {
              item["taskId"] = `${this.getOmStagesText(item.stage)} - ${
                item.valueId
              }`;

              if (item.problemLogId) item["idNum"] = `${item.problemLogId}`;
              else if (item.callerLogId) item["idNum"] = `${item.callerLogId}`;
              else if (item.maintenanceReqId)
                item["idNum"] = `${item.maintenanceReqId}`;
              else item["idNum"] = "—";
            });

            this.apps = response.data.items;
            this.formatedApps = [];
            for (var i = 0; i < this.apps.length; i++) {
              var r = {
                valueId: this.apps[i].valueId,
                applicationDate: this.$options.filters.formatDateDDMMYYYYHHmm(
                  this.apps[i].applicationDate
                ),
                billingGroup: this.apps[i].billingGroup,
                sourceTypeName: this.apps[i].sourceTypeName,
                sourceId: this.apps[i].sourceId,
                type: this.apps[i].type,
                problemAddress: this.apps[i].problemAddress,
                township: this.apps[i].township,
                OmStatusText: this.getOmStatusText(this.apps[i].status),
                OmStagesText: this.getOmStagesText(this.apps[i].stage),
                EmployeesText: this.getEmployeesText(
                  this.apps[i].workflowEmployeeId
                ),
                taskId: this.apps[i].taskId,
                idNum: this.apps[i].idNum,
                complainType: this.apps[i].complainType,
              };
              this.formatedApps.push(r);
            }
            this.options.total = response.data.total;
            this.totalRow = response.data.total;

            this.$forceUpdate();
            this.refreshDatagrid();
          } else {
            this.$alertMsg(response.data.data.text);
            this.options.total = 0;
          }
        },
        (err) => {
          this.$alertMsg(err.response.data);
          // this.$router.push("/login");
        },
        "Loading Applications"
      );
    },
    getOmStatusText(status) {
      return this.appStatus.filter((t) => t.id == status).length > 0
        ? this.appStatus.filter((t) => t.id == status)[0].name
        : "";
    },
    getOmStagesText(stage) {
      return this.appStages.filter((t) => t.id == stage).length > 0
        ? this.appStages.filter((t) => t.id == stage)[0].name
        : "";
    },
    getEmployeesText(workflowEmployeeId) {
      return this.workflowEmployees.filter((t) => t.id == workflowEmployeeId)
        .length > 0
        ? this.workflowEmployees.filter((t) => t.id == workflowEmployeeId)[0]
            .name
        : "";
    },
    getLookups() {
      axios
        .post("/Om/GetOmApplicationLookups")
        .then((response) => {
          if (response.data.data.status == 0) {
            this.appTypes = response.data.appTypes;
            this.appStatus = response.data.appStatus;
            this.appStages = response.data.appStages;
          } else {
            this.$alertMsg(response.data.data.text);
          }
        })
        .catch((e) => {
          this.$router.push("/login");
          return false;
        });
    },
    getWorkflowEmployees() {
      axios
        .post("/Om/GetWorkflowEmployees", { Value: -1 })
        .then((response) => {
          if (response.data.data.status == 0) {
            this.workflowEmployees = response.data.items;
          } else {
            this.$alertMsg(response.data.data.text);
          }
        })
        .catch((e) => {
          this.$router.push("/login");
          return false;
        });
    },
    editApp(app) {
      let id = null;
      let type = null;

      if (this.mobileView == true) {
        id = app.sourceId;
        type = app.type;
      } else {
        id = app.row.data.sourceId;
        type = app.row.data.type;
      }
      var route = "/omApplication/" + type + "/" + id;
      this.$router.push(route);
    },
    onPagination(args) {
      this.options.page = args.page;
      this.options.pageSize = args.size;
    },
    formatDateUI(date) {
      return moment(date).add(1, "days").format(uiDateFormat);
    },
    formatDateYYYYMMDD(date) {
      return moment(date, "YYYY-MM-DD"); //.format();
    },
    addDays(date, days) {
      return new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate() + days
      );
    },
    addMonthsUTC(date, count) {
      if (date && count) {
        var m,
          d = (date = new Date(+date)).getUTCDate();

        date.setUTCMonth(date.getUTCMonth() + count, 1);
        m = date.getUTCMonth();
        date.setUTCDate(d);
        if (date.getUTCMonth() !== m) date.setUTCDate(0);
      }
      return date;
    },
    addMonths(date, count) {
      if (date && count) {
        var m,
          d = (date = new Date(+date)).getDate();

        date.setMonth(date.getMonth() + count, 1);
        m = date.getMonth();
        date.setDate(d);
        if (date.getMonth() !== m) date.setDate(0);
      }
      return date;
    },
    refreshDatagrid() {
      if (this.$refs.dataGrid) {
        setTimeout(() => {
          this.$refs.dataGrid.instance.refresh();
        }, 500);
      }
    },
  },
};
